import React from 'react';
import PropTypes from 'prop-types';
import {TextInput, Toggle, Divider} from '@/components/atoms';

/**
 * LoyaltyUrl component displays the Loyalty URL input field and coupon toggle
 * Used specifically for LOYALTY reward type after the preview message
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing loyaltyUrl and couponBasedLoyaltyReward values
 * @param {Function} props.handleLoyaltyUrlChange - Handler for loyalty URL input changes
 * @param {Function} props.handleCouponBasedLoyaltyRewardChange - Handler for coupon toggle changes
 * @param {string} props.loyaltyUrlError - Error message for loyalty URL validation
 * @returns {JSX.Element} The rendered LoyaltyUrl component
 */
const LoyaltyUrl = ({
  formData,
  handleLoyaltyUrlChange,
  handleCouponBasedLoyaltyRewardChange,
  loyaltyUrlError
}) => {
  return (
    <div className='mt-4 flex flex-col'>
      <TextInput
        className='text-sm placeholder:text-sm'
        value={formData?.loyaltyUrl || ''}
        onChange={handleLoyaltyUrlChange}
        label='Loyalty URL*'
        placeholderText='Enter Loyalty URL'
        error={loyaltyUrlError}
        isDark={true}
        type='text'
        id='loyalty-url'
      />
      <Divider />
      <Toggle
        value={formData?.couponBasedLoyaltyReward || false}
        updateValue={handleCouponBasedLoyaltyRewardChange}
        uiSchema={{
          label: 'Coupon based loyalty reward',
          isDark: true,
          size: 'medium'
        }}
        id='coupon-based-loyalty-reward'
      />
    </div>
  );
};

LoyaltyUrl.propTypes = {
  formData: PropTypes.shape({
    loyaltyUrl: PropTypes.string,
    couponBasedLoyaltyReward: PropTypes.bool
  }).isRequired,
  handleLoyaltyUrlChange: PropTypes.func.isRequired,
  handleCouponBasedLoyaltyRewardChange: PropTypes.func.isRequired,
  loyaltyUrlError: PropTypes.string
};

export default LoyaltyUrl;
